<template>
  <v-form v-model="valid" ref="modifyUnderwaterInspValidation">
    <v-row class="pt-3">
      <v-col xl="6" lg="6" md="12" sm="12" cols="12">
        <LabelText
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :id="`sub_unit_Id_${id}`"
          :isEditable="false"
          label="WA.27 Sub Unit"
          v-model="subUnitId"
        >
        </LabelText>
        <LabelCheckbox
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          class="labelCheckbox"
          :id="`is_current_${id}`"
          label="WA.28 Current Inspection?"
          :showColon="false"
          editIndent
          :isEditable="isEditable"
          v-model="underwaterInspection.previousCurrent"
          @update:modelValue="underwaterInspectionUpdated()"
        >
        </LabelCheckbox>

        <LabelText
          class="pt-1"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :id="`scbi_code_${id}`"
          :isEditable="false"
          label="WA.29 SCBI Code"
          v-model="underwaterInspection.scbiCode"
        >
        </LabelText>
        <LabelText
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :id="`scbi_case_${id}`"
          :isEditable="false"
          label="WA.30 SCBI Case"
          v-model="underwaterInspection.scbiCase"
        >
        </LabelText>
        <LabelSelect
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :isRequired="isEditable ? true : false"
          :id="`scour_rating_${id}`"
          label="WA.31 Scour Rating"
          :refTable="REFERENCE_TABLE.OBSERVED_SCOUR_RATING"
          :isEditable="isEditable"
          v-model="underwaterInspection.obsScourRating"
          @update:modelValue="underwaterInspectionUpdated()"
        ></LabelSelect>
        <LabelSelect
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :isRequired="isEditable ? true : false"
          :id="`change_since_last_insp_${id}`"
          label="WA.32 Change Since Last Insp"
          :refTable="REFERENCE_TABLE.CHANGE_SINCE_LAST_INSP"
          :isEditable="isEditable"
          v-model="underwaterInspection.changeSinceLastInsp"
          @update:modelValue="
            {
              underwaterInspectionUpdated();
              calculateScourCritical();
            }
          "
        ></LabelSelect>
        <LabelSelect
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :isRequired="isEditable ? true : false"
          :id="`scour_hole_${id}`"
          label="WA.33 Scour hole"
          :refTable="REFERENCE_TABLE.SCOUR_HOLE"
          :isEditable="isEditable"
          v-model="underwaterInspection.scourHole"
          @update:modelValue="
            {
              underwaterInspectionUpdated();
              calculateScourCritical();
            }
          "
        ></LabelSelect>
        <LabelSelect
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :isRequired="isEditable ? true : false"
          :id="`debris_potn_${id}`"
          label="WA.34 Debris Potential"
          :refTable="REFERENCE_TABLE.DEBRIS_POTENTIAL"
          :isEditable="isEditable"
          v-model="underwaterInspection.debrisPotential"
          @update:modelValue="underwaterInspectionUpdated()"
        ></LabelSelect>
        <LabelSelect
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :isRequired="isEditable ? true : false"
          :id="`scourability_${id}`"
          label="WA.35 Scourability"
          :refTable="REFERENCE_TABLE.SUBSTRUCTURE_SCOURABILITY"
          :isEditable="isEditable"
          v-model="underwaterInspection.subScour"
          @update:modelValue="underwaterInspectionUpdated()"
        ></LabelSelect>
        <LabelSelect
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :isRequired="isEditable ? true : false"
          :id="`opening_adeq_channel_${id}`"
          label="WA.36 Opening Adeq Channel"
          :refTable="REFERENCE_TABLE.OPENING_ADEQUACY_CHANNEL"
          :isEditable="isEditable"
          v-model="underwaterInspection.openAdeqChannel"
          @update:modelValue="underwaterInspectionUpdated()"
        ></LabelSelect>
        <LabelSelect
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :isRequired="isEditable ? true : false"
          :id="`seidment_${id}`"
          label="WA.37 Sediment"
          :refTable="REFERENCE_TABLE.SEDIMENT_DEPOSITS"
          :isEditable="isEditable"
          v-model="underwaterInspection.sedDeposit"
          @update:modelValue="underwaterInspectionUpdated()"
        ></LabelSelect>
        <LabelSelect
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :isRequired="isEditable ? true : false"
          :id="`alignment_${id}`"
          label="WA.38 Alignment"
          :refTable="REFERENCE_TABLE.ALIGNMENT"
          :isEditable="isEditable"
          v-model="underwaterInspection.alignment"
          @update:modelValue="underwaterInspectionUpdated()"
        ></LabelSelect>
        <LabelSelect
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :isRequired="isEditable ? true : false"
          :id="`velocity_stream_slope_${id}`"
          label="WA.39 Velocity Stream Slope"
          :refTable="REFERENCE_TABLE.VELOCITY_STREAM_SLOPE"
          :isEditable="isEditable"
          v-model="underwaterInspection.veloStreamSlope"
          @update:modelValue="underwaterInspectionUpdated()"
        ></LabelSelect>
      </v-col>
      <v-col xl="6" lg="6" md="12" sm="12" cols="12">
        <LabelSelect
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :isRequired="isEditable ? true : false"
          :id="`subunit_Type_${id}`"
          label="WA.40 Pier/Abutment Type"
          :options="pierAbutTypes"
          :isEditable="isEditable"
          v-model="underwaterInspection.subUnitType"
          @update:modelValue="
            {
              underwaterInspectionUpdated();
              calculateScourCritical();
            }
          "
        ></LabelSelect>
        <LabelSelect
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :isRequired="isEditable ? true : false"
          :id="`inv_found_type_${id}`"
          label="WA.41 Inv Foundation Type"
          :refTable="REFERENCE_TABLE.PA_FOUNDATION_TYPE"
          :isEditable="isEditable"
          v-model="paFoundationType"
        ></LabelSelect>
        <LabelSelect
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :id="`found_type_${id}`"
          :isEditable="false"
          :refTable="REFERENCE_TABLE.OSA_FOUNDATION_TYPE"
          label="WA.42 OSA Foundation Type"
          v-model="foundType"
        >
        </LabelSelect>
        <LabelSelect
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :isRequired="isEditable ? true : false"
          :id="`streambed_material_${id}`"
          label="WA.43 Streambed Material"
          :refTable="REFERENCE_TABLE.STREAM_BED_MATERIAL"
          :isEditable="isEditable"
          v-model="underwaterInspection.streamBedMaterial"
          @update:modelValue="
            {
              underwaterInspectionUpdated();
              calculateScourCritical();
            }
          "
        ></LabelSelect>
        <LabelSelect
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :isRequired="isEditable ? true : false"
          :id="`uw_insp_type_${id}`"
          label="WA.44 UW Inspection Type"
          :refTable="REFERENCE_TABLE.UNDERWATER_INSPECTION_TYPE"
          :isEditable="isEditable"
          v-model="underwaterInspection.underwaterInspType"
          @update:modelValue="underwaterInspectionUpdated()"
        ></LabelSelect>
        <LabelText
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :isRequired="isEditable ? true : false"
          :id="`ob_scour_depth_${id}`"
          :type="'number'"
          appendWith=" ft"
          maxlength="4"
          :decimalPlaces="1"
          :isEditable="isEditable"
          label="WA.45  Observed Scour Depth"
          v-model="underwaterInspection.obsScourDepth"
          :rules="
            isEditable
              ? [
                  (value) => {
                    return valueInRangeRule(value, 0.0, 99.9);
                  },
                ]
              : []
          "
          @update:modelValue="underwaterInspectionUpdated()"
        />
        <LabelText
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :isRequired="isEditable ? true : false"
          :id="`max_water_depth_${id}`"
          :type="'number'"
          appendWith=" ft"
          maxlength="4"
          :decimalPlaces="1"
          :isEditable="isEditable"
          label="WA.46 Water Depth"
          v-model="underwaterInspection.maxWaterDepth"
          :rules="
            isEditable
              ? [
                  (value) => {
                    return valueInRangeRule(value, 0.0, 99.0);
                  },
                ]
              : []
          "
          @update:modelValue="underwaterInspectionUpdated()"
        />
        <LabelCheckbox
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          class="labelCheckbox"
          :id="`movement_${id}`"
          label="WA.47 Movement Indicator"
          :isEditable="isEditable"
          v-model="underwaterInspection.movement"
          @update:modelValue="
            {
              underwaterInspectionUpdated();
              calculateScourCritical();
            }
          "
        >
        </LabelCheckbox>
        <LabelCheckbox
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          class="labelCheckbox"
          :id="`scour_undermine_ind_${id}`"
          label="WA.48 Scour/Undermine Indicator"
          :isEditable="isEditable"
          v-model="underwaterInspection.scourUndermine"
          @update:modelValue="underwaterInspectionUpdated()"
        >
        </LabelCheckbox>
        <LabelCheckbox
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          class="labelCheckbox"
          :id="`countermeasures_${id}`"
          label="WA.49 Countermeasures"
          :isEditable="isEditable"
          v-model="underwaterInspection.counterMeasure"
          @update:modelValue="underwaterInspectionUpdated()"
        >
        </LabelCheckbox>
        <LabelText
          class="pt-1"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :id="`onehundred_year_flood_depth_${id}`"
          :type="'number'"
          appendWith=" ft"
          maxlength="4"
          :decimalPlaces="1"
          :isEditable="isEditable"
          :showPlaceholder="true"
          label="WA.50 100 YR Flood Scour Depth"
          v-model="calcScourDepthOneHundred"
          :rules="
            isEditable
              ? [
                  (value) => {
                    return valueInRangeRule(value, 0.0, 99.9);
                  },
                ]
              : []
          "
        />
        <LabelText
          class="pt-2"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="5"
          :textMd="6"
          :textSm="6"
          :id="`fivehundred_year_flood_depth_${id}`"
          :type="'number'"
          appendWith=" ft"
          maxlength="4"
          :decimalPlaces="1"
          :isEditable="isEditable"
          :showPlaceholder="true"
          label="WA.51 500 YR Flood Scour Depth"
          v-model="calcScourDepthFiveHundred"
          :rules="
            isEditable
              ? [
                  (value) => {
                    return valueInRangeRule(value, 0.0, 99.9);
                  },
                ]
              : []
          "
        />
        <LabelCheckbox
          class="pt-1 labelCheckbox"
          :labelXl="5"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :id="`in_flood_plain_${id}`"
          label="WA.52 In 500yr Flood Plain?"
          :showColon="false"
          :isEditable="false"
          :indent="isEditable ? false : true"
          v-model="isStructureUnitIn500YrFpValue"
        >
        </LabelCheckbox>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-3">
        <LabelText
          :labelXl="12"
          :labelLg="12"
          :labelMd="12"
          :labelSm="12"
          :textXl="12"
          :textLg="12"
          :textMd="12"
          :textSm="12"
          :id="`textarea_notes_${id}`"
          v-model="underwaterInspection.underwaterInspDesc"
          @update:modelValue="underwaterInspectionUpdated()"
          :isEditable="isEditable"
          :counter="commentsMaxLength"
          :maxlength="commentsMaxLength"
          persistent-counter
          label="WA.53 Notes"
          auto-grow
          rows="1"
          type="textarea"
        >
        </LabelText>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { computed, ref, onMounted } from "vue";
import { ENV_CONFIG_PROPERTY, CONFIG_SORT_BY } from "@/constants/EnvConfigProperties";
import { useConfigStore } from "@/stores/config";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelText from "@/components/common/LabelText.vue";
import LabelCheckbox from "@/components/common/LabelCheckbox.vue";
import { UNDERWATER_INSP } from "@/data/underwaterInspection";
import { clone } from "@/util/clone";
import { SORT_ORDER, TYPES } from "@/constants/CommonWebConstants";
import { isStructureUnitIn500YrFp } from "@/composables/waterways.js";
import { useSubstructureStore } from "@/components/inspection/store/substructure";
import { useCulvertStore } from "@/components/inspection/store/culvert";
import { INSPECTION_PAGES } from "@/constants/Inspections";
import { valueInRangeRule } from "@/composables/validationRules";

export default {
  name: "UnderwaterInspection",
  emits: ["updateUnderwaterInspection"],
  props: {
    id: {},
    strUnitKey: { default: null },
    strUnitLabel: { default: null },
    legacyStructureType: { default: null },
    isEditable: { default: false },
    pageValue: { default: "" },
  },
  setup(props, context) {
    let structureValue = computed(() => {
      if (props.pageValue == INSPECTION_PAGES.SUBSTRUCTURE) {
        const substructureStore = useSubstructureStore();
        return substructureStore.pageData;
      } else if (props.pageValue == INSPECTION_PAGES.CULVERT) {
        const culvertStore = useCulvertStore();
        return culvertStore.culvertData;
      } else {
        return null;
      }
    });
    const configStore = useConfigStore();

    const structureUnit = computed(() => {
      return structureValue.value.structureUnits.find((structure) => {
        return structure.strUnitKey == props.strUnitKey;
      });
    });

    const commentsMaxLength = computed(() => {
      return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.INSPECTION_COMMENT_MAX_LENGTH);
    });

    const pierAbutTypes = computed(() => {
      if (props.legacyStructureType == "B") {
        return configStore
          .getReferenceValues(
            REFERENCE_TABLE.PIER_ABUTMENT_TYPE,
            CONFIG_SORT_BY.VALUE,
            SORT_ORDER.ASC,
            false,
            TYPES.NUMBER,
          )
          ?.filter((pierAbutType) => pierAbutType.value <= 10);
      } else if (props.legacyStructureType == "P") {
        return configStore
          .getReferenceValues(
            REFERENCE_TABLE.PIER_ABUTMENT_TYPE,
            CONFIG_SORT_BY.VALUE,
            SORT_ORDER.ASC,
            false,
            TYPES.NUMBER,
          )
          ?.filter((pierAbutType) => pierAbutType.value >= 21);
      } else if (props.legacyStructureType == "C") {
        return configStore
          .getReferenceValues(
            REFERENCE_TABLE.PIER_ABUTMENT_TYPE,
            CONFIG_SORT_BY.VALUE,
            SORT_ORDER.ASC,
            false,
            TYPES.NUMBER,
          )
          ?.filter((pierAbutType) => pierAbutType.value == 10 || pierAbutType.value == 2);
      } else {
        return configStore.getReferenceValues(
          REFERENCE_TABLE.PIER_ABUTMENT_TYPE,
          CONFIG_SORT_BY.VALUE,
          SORT_ORDER.ASC,
          false,
          TYPES.NUMBER,
        );
      }
    });

    let valid = ref(true);
    onMounted(async () => {
      if (props.pageValue == INSPECTION_PAGES.SUBSTRUCTURE) {
        await validate();
      }
    });
    let modifyUnderwaterInspValidation = ref(null);

    async function validate() {
      await modifyUnderwaterInspValidation.value?.validate();
    }

    let isStructureUnitIn500YrFpValue = computed(() => {
      return isStructureUnitIn500YrFp(props.strUnitKey, structureValue?.value?.inspectionsUnderwater) ? "1" : "0";
    });

    let underwaterInspToAdd = ref();

    underwaterInspToAdd.value = clone(UNDERWATER_INSP);

    underwaterInspToAdd.value.brkey = structureValue?.value?.brkey;

    underwaterInspToAdd.value.inspectionId = structureValue?.value?.inspectionId;

    underwaterInspToAdd.value.strUnitKey = props.strUnitKey;

    let subUnitId = ref();

    subUnitId.value = props.strUnitKey + "-" + props.strUnitLabel;

    function getUnderwaterInspection() {
      let underwaterInsp = structureValue?.value?.inspectionsUnderwater?.find(
        (element) => element?.strUnitKey == props.strUnitKey,
      );
      if (underwaterInsp) {
        return underwaterInsp;
      } else {
        structureValue.value.inspectionsUnderwater.push(underwaterInspToAdd.value);
        return structureValue.value.inspectionsUnderwater.at(-1);
      }
    }

    let subScourRating = computed({
      get() {
        let obsScourRatings = [];
        if (structureValue?.value?.inspectionsUnderwater) {
          for (let underwaterInspection of structureValue.value.inspectionsUnderwater) {
            obsScourRatings.push(Number.parseInt(underwaterInspection?.obsScourRating));
          }
        }

        if (obsScourRatings == []) {
          return -1;
        } else {
          return Math.min(...obsScourRatings);
        }
      },
    });

    function calculateScourCriticalCategory() {
      if (subScourRating.value == -1) {
        structureValue.value.scourCriticalCat = "--";
      } else if (
        Number.parseInt(structureValue.value?.scourCritical) <= 2 ||
        Number.parseInt(structureValue.value?.scourCritical) == 6 ||
        subScourRating.value <= 3
      ) {
        structureValue.value.scourCriticalCat = "A";
      } else if (Number.parseInt(structureValue.value?.scourCritical) == 3 && subScourRating.value == 4) {
        structureValue.value.scourCriticalCat = "B";
      } else if (
        Number.parseInt(structureValue.value?.scourCritical) == 3 &&
        subScourRating.value <= 9 &&
        subScourRating.value >= 5
      ) {
        structureValue.value.scourCriticalCat = "C";
      } else if (
        Number.parseInt(structureValue.value?.scourCritical) == 4 ||
        Number.parseInt(structureValue.value?.scourCritical) == 7
      ) {
        structureValue.value.scourCriticalCat = "D";
      } else {
        structureValue.value.scourCriticalCat = "--";
      }
    }

    function calculateScourCritical() {
      if (structureValue.value.scourCalculated == "1") {
        calculateSCBI();
        configStore.getScourCriticalBridgeIndicator(structureValue.value);
        calculateScourCriticalCategory();
      }
    }

    const underwaterInspection = computed({
      get() {
        return getUnderwaterInspection();
      },
    });

    const underwaterInspectionUpdated = () => {
      context.emit("updateUnderwaterInspection");
    };

    const paFoundationType = computed({
      get() {
        return underwaterInspection.value.invFoundType;
      },
      set(paFoundationTypeParam) {
        let osaFoundType = "";
        let paFoundType = paFoundationTypeParam?.charAt(0);
        if (paFoundType == "A") {
          osaFoundType = "1";
        } else if (["R", "K", "L"].includes(paFoundType)) {
          osaFoundType = "2";
        } else if (["B", "C", "D", "E", "F", "G", "H", "I", "J", "S"].includes(paFoundType)) {
          osaFoundType = "3";
        } else if (paFoundType == "O") {
          osaFoundType = "4";
        } else if (["P", "X"].includes(paFoundType)) {
          osaFoundType = "5";
        }
        underwaterInspection.value.invFoundType = paFoundationTypeParam;
        underwaterInspection.value.foundType = osaFoundType;
        underwaterInspectionUpdated();
        calculateScourCritical();
      },
    });

    const foundType = computed({
      get() {
        return underwaterInspection.value ? underwaterInspection.value?.foundType : [];
      },
    });

    const calcScourDepthOneHundred = computed({
      get() {
        return underwaterInspection.value?.calcScourDepth100;
      },
      set(calcScourDepthOneHundredParam) {
        underwaterInspection.value.calcScourDepth100 = calcScourDepthOneHundredParam;
        underwaterInspectionUpdated();
      },
    });
    const calcScourDepthFiveHundred = computed({
      get() {
        return underwaterInspection.value?.calcScourDepth500;
      },
      set(calcScourDepthFiveHundredParam) {
        underwaterInspection.value.calcScourDepth500 = calcScourDepthFiveHundredParam;
        underwaterInspectionUpdated();
      },
    });

    function calculateSCBI() {
      const returnObject = configStore.getScourCriticalBridgeIndicatorReturnObject(
        structureValue.value,
        underwaterInspection.value,
        structureUnit.value,
      );
      underwaterInspection.value.scbiCode = returnObject ? returnObject.scbiCode : "6";
      underwaterInspection.value.scbiCase = returnObject ? returnObject.scbiCase : "4";
    }

    return {
      underwaterInspectionUpdated,
      calculateSCBI,
      structureValue,
      isStructureUnitIn500YrFpValue,
      pierAbutTypes,
      valueInRangeRule,
      calculateScourCritical,
      underwaterInspection,
      modifyUnderwaterInspValidation,
      valid,
      validate,
      subUnitId,
      commentsMaxLength,
      REFERENCE_TABLE,
      calcScourDepthOneHundred,
      calcScourDepthFiveHundred,
      foundType,
      paFoundationType,
    };
  },
  components: {
    LabelSelect,
    LabelText,
    LabelCheckbox,
  },
};
</script>
